import { render } from "./CredEditDetail.vue?vue&type=template&id=0ab95726&scoped=true"
import script from "./CredEditDetail.vue?vue&type=script&lang=js"
export * from "./CredEditDetail.vue?vue&type=script&lang=js"

import "./CredEditDetail.vue?vue&type=style&index=0&id=0ab95726&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab95726"]])

export default __exports__